import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import type { Theme, SxProps } from '@mui/material/styles';

const sharedInputStyles = (theme: Theme) => ({
  '& .MuiOutlinedInput-root': {
    fontSize: theme.typography.body2.fontSize,
    padding: 0,
    '& textarea': {
      padding: theme.spacing(1.5, 1),
      border: 'none',
      fontSize: theme.typography.body2.fontSize,
      marginBottom: 0,
      '&:focus': {
        outline: 'none',
      },
    },
  },
});

const LegacyCaptionField = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(1),
  ...sharedInputStyles(theme),
  // Preserve the fixed height from before the sharedInputStyles refactor
  '& .MuiOutlinedInput-root textarea': {
    height: theme.spacing(5),
  },
}));

const readOnlyCaptionSx: SxProps<Theme> = {
  pt: 1,
  whiteSpace: 'pre-wrap',
  color: 'text.secondary',
  fontSize: (theme) => theme.typography.body2.fontSize,
};

export { LegacyCaptionField, readOnlyCaptionSx };
